export default {"Pagination":"Pagination-module__Pagination__8AEjq"};